import axios from 'axios';
import { store } from '../store'; // Redux store
import { setUser, clearAuth } from '../store/slices/authSlice';
import type { User } from '../types/auth';
import { NavigateFunction } from 'react-router-dom';

let navigate: NavigateFunction;

// Function to set navigate (call in Layout or App)
export const setNavigate = (nav: NavigateFunction) => {
  navigate = nav;
};

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000';

const instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.token = token;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const msg = error?.response?.data?.result;

    if (msg === 'User account is suspended') {
      const user = store.getState().auth.user;
      if (user) {
        store.dispatch(
          setUser({
            ...user,
            suspended: true,
          } as User)
        );
      }
      if (navigate) navigate('/suspended', { replace: true });

      // RETURN A REJECTED PROMISE WITHOUT ERROR MESSAGE TO SUPPRESS TOAST
      return new Promise(() => {}); // hang the promise, no catch triggers
    }

    if (msg === 'User does not have dashboard access') {
      store.dispatch(clearAuth());
      localStorage.removeItem('token');
      if (navigate) navigate('/login', { replace: true });

      return new Promise(() => {}); // prevent original API catch from firing
    }

    return Promise.reject(error); // all other errors still propagate normally
  }
);


export default instance;
